import { useSelector } from 'react-redux';
import { selectIsOrionAdviser } from '../../../../AdviserArea/AdviserAreaSelector';

export const useIsOrionAdviser = (): boolean => {
  return useSelector(selectIsOrionAdviser);
};
